import { Component, output } from '@angular/core';

@Component({
  selector: 'wf-intervention-back-dialog',
  templateUrl: './intervention-back-dialog.component.html',
  styleUrl: './intervention-back-dialog.component.css'
})
export class InterventionBackDialogComponent {
  readonly onPress = output<boolean>();

  onConfirmClick()
  {
    this.onPress.emit(true);
  }

  onCancelClick()
  {
    this.onPress.emit(false);
  }
}
